// Теги, включающие кнопку «Связаться с клиентом» для фармацевта на аптеке
// (source) или на сети (network). Разные id для дев- и прод-окружения.
const IS_DEV_AREA = Boolean(process.env.REACT_APP_DEV_AREA);
export const CONTACT_CLIENT_SOURCE_TAG_ID = IS_DEV_AREA ? 1057 : 1199;
export const CONTACT_CLIENT_NETWORK_TAG_ID = IS_DEV_AREA ? 1058 : 1200;
